<template>
  <div id="app">
      <router-view v-if='noLayout===true'/>
      <el-container class='container-style' v-else-if="noLayout===false && hasAuthed">
          <Sidebar/>
          <el-container>
              <Topbar />
               <el-main style='margin-top:60px;' v-loading="Loading">
                        <Tagview v-if='isTagview' />
                        <router-view v-else/>
                </el-main>
          </el-container>
      </el-container>
      <MToggle/>         
  </div>
</template>
<script>
import Sidebar from '@/components/sidebar'
import Topbar from '@/components/topbar'
import Tagview from '@/components/tagview'
import MToggle from '@/components/mtoggle'

export default {
  name: 'app',
  computed:{
     isTagview(){
          return this.$store.getters.isTagViewed
     },
     Loading(){
          return this.$store.getters.LoadingState
     },
     noLayout(){
          if(this.$route.name!=undefined && this.$route.name!=''){
               const whiteList=['login','404'] 
               if(whiteList.includes(this.$route.name)){
                    return true
               }else{
                    return false
               }
          }
          return ''
     },
     hasAuthed(){
          return this.$store.state.user.token!=''?true:false 
     }
  },
  components:{
     Sidebar,
     Topbar,
     Tagview,
     MToggle
  }
}
</script>

<style lang="scss">
.container-style{min-height: 100vh;}
</style>
